
import chatDuration from './chatDuration'
import selectedRow from './selectedRow'
import filteringByNull from './filteringByNull'
import groupInterval from './groupInterval'
import otherAfter from './otherAfter'
// import otherBefore from './otherBefore'
import grouping from './grouping'
import agents from './agents'
import timeZones from './timeZones'

/* this specifies the queue in which the middleware will be executed */
export const middlewaresForRequest = [
  // otherBefore.middlewareForRequest,
  grouping.middlewareForRequest,
  selectedRow.middlewareForRequest,
  filteringByNull.middlewareForRequest,
  groupInterval.middlewareForRequest,
  chatDuration.middlewareForRequest,
  timeZones.middlewareForRequest,
  otherAfter.middlewareForRequest,
]
export const middlewaresForResponse = [
  grouping.middlewareForResponse,
  groupInterval.middlewareForResponse,
  agents.middlewareForResponse,
  timeZones.middlewareForResponse,
  filteringByNull.middlewareForResponse,
]
